var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeshPortfolioLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 26,
    viewBox: "0 0 94 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12082_3283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7412 19.9675L37.7053 16.6395C39.0783 18.1995 40.9794 19.2395 43.0918 19.2395C44.3592 19.2395 45.6266 18.8235 46.6828 18.0955C47.739 17.2635 48.4783 16.2235 48.7951 14.9755H41.1906V10.2955H48.5839C48.1614 9.15148 47.4221 8.21548 46.4715 7.48748C45.521 6.75948 44.2536 6.44748 42.9862 6.44748C40.9794 6.44748 39.0783 7.27948 37.7053 8.73548L33.1637 4.99148C35.4873 2.07948 39.0783 0.311482 42.8805 0.415482C44.676 0.415482 46.4715 0.831482 48.0558 1.45548C49.5345 2.07948 51.0131 2.91148 52.1749 4.05548C54.4985 6.34348 55.9772 9.56748 55.9772 12.8955C55.9772 15.0795 55.3435 17.1595 54.1817 19.1355C53.1255 21.0075 51.5412 22.4635 49.6401 23.5035C47.739 24.5435 45.521 25.4795 43.303 25.3755C41.1906 25.4795 39.0783 24.6475 37.1772 23.8155C35.3817 22.7755 33.903 21.5275 32.7412 19.9675Z",
    fill: "#0A0B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1465 0.415039H66.5397V19.135H72.8768V0.415039H80.2701V19.135H86.6072V0.415039H94.0004V24.335H59.1465",
    fill: "#0A0B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1236 0.416016L14.364 9.77602L8.44944 0.416016H0V24.336H7.39326V10.816C9.18876 13.208 10.8787 15.704 12.6742 18.096H15.8427C17.5326 15.704 19.4337 13.208 21.1236 10.816V24.336H28.5169V0.416016H21.1236Z",
    fill: "#0A0B0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12082_3283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeshPortfolioLogo);
export default __webpack_public_path__ + "static/media/meshPortfolioLogo.08a89ba20d7778ac8535d944b4af75b5.svg";
export { ForwardRef as ReactComponent };